import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../../utils/api";
import { RootState } from "../../rootReducer";

// Asigna locations al usuario bajo el perfil asignado
export const assignLocations = createAsyncThunk(
  "userProfileLocation/assignLocations",
  async (arg, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;
      const selectedLocations = state.userProfileLocation.selectedLocations;
      const locationsToSave = [...selectedLocations];
      const assignedLocations = state.userProfileLocation.assignedLocations;
      const idsToDelete: string[] = [];

      // Se comprueba si los locations ya asignados se encuentran dentro de los seleccionados.
      // Si los encuentra los elimina del listado para crear registros (locationsToSave).
      // Si no los encuentra guarda el id en listado para eliminar registros (IdsToDelete).
      assignedLocations.forEach(async (element) => {
        if (locationsToSave.includes(element.location)) {
          const indexToDelete = locationsToSave.indexOf(element.location);
          locationsToSave.splice(indexToDelete, 1);
        } else {
          idsToDelete.push(element.id);
        }
      });
      // Genera listado de ids de locations para guardar registros
      let id:string = ''
      const idsLocationsToSave = locationsToSave.map((element) => {
        id = `${element.id}`
        return element.id
      });
      const url = new URL(`${api.hojasDeCargoURL}ProductsHojaCargo?hojaCargo=${id}`);
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      // Eliminar registros
      if (idsToDelete.length > 0) {
        const url = new URL(`${api.baseURL}userprofilelocation/delete-list`);
        let response = await fetch(url.toJSON(), {
          body: JSON.stringify({
            toDelete: idsToDelete.toString(),
          }),
          method: "POST",
          headers: headers,
        });
        if (!response.ok) {
          throw response.statusText;
        }
      }

      // Crea registros
      if (idsLocationsToSave.length > 0) {
        const url = new URL(`${api.baseURL}userprofilelocation/create-list`);
        let response = await fetch(url.toJSON(), {
          body: JSON.stringify({
            user: state.userProfileLocation.user.id,
            profile: state.userProfileLocation.profile.id,
            toAddLocationIds: idsLocationsToSave.toString(),
          }),
          method: "POST",
          headers: headers,
        });
        if (!response.ok) {
          throw response.statusText;
        }
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
